import "quill/dist/quill.snow.css";
import "katex/dist/katex.min.css";
import "./RawHTML.css";

const RawHTMLComponent = ({ htmlContent, padding = true }) => {
    return (
        <div className={`ql-editor ${padding ? '' : 'no-padding'}`}>
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
    );
};

export default RawHTMLComponent;